import React from "react";
import { cn } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj } from "../lib/helpers";
import ContentColumn from "./content-column";

import * as styles from "../styles/components/multi-column-content-with-image.module.css";

const MultiColumnContentWithImage = (props) => {

  const {
    heading,
    image,
    content
  } = props;

  return (
    <div className={styles.root}>
      <div className={cn("grid", styles.customGrid)}>
        <div className={cn("col-12 col-md-6", styles.customCol, styles.image)}>
          {image && image.asset && (
            <img
              src={imageUrlFor(buildImageObj(image))
                .auto("format")
                .url()}
              alt={image.alt}
            />
          )}
        </div>
        <div className={cn("col-12 col-md-6", styles.customCol, styles.text)}>
          <div className="content-md">
            {heading && <h2 className={cn("h3", styles.heading)}>{heading}</h2>}
            {(content && content.length) 
              ? <div className="grid">
                  {content.map(col => {
                    return (
                      <div className={cn("col-12 col-xl-6", styles.item)} key={col._key}>
                        <ContentColumn icon={col.icon} heading={col.heading} content={col._rawContent} link={col.link} />
                      </div>
                    );
                  })}
                </div>
              : null
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default MultiColumnContentWithImage;
